import React, {Component} from 'react';
import './Member.css';
import '../css/styles.css'
import { IKaitenMember } from '../../../../KaitenServer/src/DataSource/DataSet/dataset';

interface IMemberProps {
  member: IKaitenMember;
}

interface IMemberState{
}
export default class Member extends Component <IMemberProps, IMemberState> {

  constructor (props?:any) {
    super(props);
    this.state = {
    }
  }

  render(): React.ReactNode {
    return (
      <>
      <img className='Member shadow' src={this.props.member.avatar_initials_url!} title={this.props.member.email}></img>
      </>
    );
  }
}
